import type { PayloadAction } from '@reduxjs/toolkit';
import { createAction, createSlice } from '@reduxjs/toolkit';
import type { SortingPosition } from 'src/components/Sorting/types';
import type { ReviewStore } from './types';

export const initialState: ReviewStore = {
  fetching: false,
  isLoadingNew: false,
  visibleCount: 10,
  // вариант отображения отзывов
  variant: 'old',
  // для старого типа отзывов
  data: [],
  // для новых отзывов
  reviews: [],
  pagination: {
    page: 1,
    total: 0,
  },
  sorting: {
    order: 'desc',
    field: 'date',
  },
};

const getState = (state) =>
  typeof state.toJS === 'function' ? state.toJS() : state;

const reviewSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    setVisibleCount: (state, action: PayloadAction<number>) => {
      state.visibleCount = action.payload;
    },
    setVariant: (state, action: PayloadAction<ReviewStore['variant']>) => ({
      ...getState(state),
      variant: action.payload,
    }),
    setReviewsData: (state, action: PayloadAction<ReviewStore['data']>) => {
      // @ts-ignore
      if (typeof state?.toJS === 'function') {
        return {
          // @ts-ignore
          ...state.toJS(),
          data: action.payload,
        };
      }
      const prevState = state.data;
      return {
        ...state,
        data: [...prevState, ...action.payload],
      };
    },
    setReviews: (state, action: PayloadAction<ReviewStore['reviews']>) => {
      // @ts-ignore
      if (typeof state?.toJS === 'function') {
        return {
          // @ts-ignore
          ...state.toJS(),
          reviews: action.payload,
        };
      }
      const prevState = state.reviews;
      return {
        ...state,
        reviews: [...prevState, ...action.payload],
      };
    },
    setReviewsTotalCount: (
      state,
      action: PayloadAction<ReviewStore['pagination']['total']>,
    ) => ({
      ...getState(state),
      pagination: {
        ...state.pagination,
        total: action.payload,
      },
    }),
    setReviewsPage: (
      state,
      action: PayloadAction<ReviewStore['pagination']['page']>,
    ) => ({
      ...getState(state),
      pagination: {
        ...state.pagination,
        page: action.payload,
      },
    }),
    setFetchingStatus: (
      state,
      action: PayloadAction<ReviewStore['fetching']>,
    ) => ({
      ...getState(state),
      fetching: action.payload,
    }),
    setLoadingNewReviews: (
      state,
      action: PayloadAction<ReviewStore['isLoadingNew']>,
    ) => ({
      ...getState(state),
      isLoadingNew: action.payload,
    }),
    setSorting: (state, action: PayloadAction<ReviewStore['sorting']>) => ({
      ...getState(state),
      sorting: action.payload,
    }),
    clearReviews: (state) => ({
      ...state,
      reviews: [],
    }),
  },
});

export const {
  setReviewsData,
  setReviews,
  setReviewsTotalCount,
  setReviewsPage,
  setFetchingStatus,
  setVisibleCount,
  setLoadingNewReviews,
  setSorting,
  clearReviews,
  setVariant,
} = reviewSlice.actions;

export const showMoreReviews = createAction('reviews/showMoreReviews');
export const changeSortingAction = createAction<SortingPosition>(
  'reviews/changeSortingAction',
);
const { name, reducer } = reviewSlice;
export { reducer as default, name };
